import { useState, useCallback } from "react";
import { useAuth, authorizedAxios } from "@moonscape/shared";

interface DetectionResult {
  detected_exchange: string | null;
  display_name?: string;
  parser?: string;
  confidence: number;
  columns?: string[];
  row_count?: number;
  message?: string;
}

export const useDetectCSV = () => {
  const { getToken } = useAuth();
  const [isDetecting, setIsDetecting] = useState(false);
  const [detection, setDetection] = useState<DetectionResult | null>(null);

  const detect = useCallback(async (file: File): Promise<DetectionResult | null> => {
    setIsDetecting(true);
    setDetection(null);

    try {
      const token = await getToken();
      const formData = new FormData();
      formData.append("file", file);

      const res = await authorizedAxios(token).post(
        "/import/file/detect",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          timeout: 15000,
        }
      );

      const result = res.data as DetectionResult;
      setDetection(result);
      return result;
    } catch (err) {
      console.error("[useDetectCSV] Detection failed:", err);
      setDetection(null);
      return null;
    } finally {
      setIsDetecting(false);
    }
  }, [getToken]);

  const reset = useCallback(() => {
    setDetection(null);
    setIsDetecting(false);
  }, []);

  return { detect, isDetecting, detection, reset };
};
